import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Button, LoadingButton } from '@olxbr/ds-core'
import { Card, Link, Alertbox } from '@olxbr/ds-web'
import { ErrorAlertbox } from '../../atoms/ErrorAlertbox/ErrorAlertbox'
import useWindowSize from '../../../util/useWindowSize'
import { breakpoints } from '../../../util/medias'
import { CaptionButton } from '../../atoms/CaptionButton'

const ErrorAlertboxWrapper = styled.div`
  display: flex;
  & div {
    width: 100%;
  }
`

const Content = styled(Card)`
  padding: 24px 55px;
  min-height: 112px;
  max-width: 500px;
  margin: auto;

  @media (max-width: ${breakpoints.mobile}px) {
    padding: 0;
  }
`

const FlexText = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
`

const BackLink = styled(Link)`
  align-self: center;
`

const SendButton = styled(LoadingButton)`
  margin-top: var(--spacing-3);

  @media (max-width: ${breakpoints.tablet}px) {
    margin-top: var(--spacing-2);
  }
`

export const RevalidateCard = ({
  children,
  title,
  alertDescription,
  onBack,
  description,
  onSend,
  onClickFooterButton,
  buttonDescription,
  footerDescription,
  disableSendButton,
  isLoading,
  showFooter,
  error,
  caption,
  callBackCaptionButton,
}) => {
  const { isMobile } = useWindowSize()

  return (
    <Content variant={isMobile ? 'empty' : 'outlined'}>
      <div className="flex mt-2 justify-center">
        <span className="typo-title-medium text-neutral-130">{title}</span>
      </div>
      <FlexText>
        <span className="typo-body-medium text-neutral-120">{description}</span>
      </FlexText>
      {error && (
        <ErrorAlertboxWrapper>
          <ErrorAlertbox
            title={error.title}
            showContactUs={error.showContactUs}
            customLink={error.customLink}
          >
            {error.message}
          </ErrorAlertbox>
        </ErrorAlertboxWrapper>
      )}
      {children}
      {showFooter && caption && !isMobile && (
        <CaptionButton
          description={caption.description}
          buttonDescription={caption.buttonDescription}
          onClick={() => callBackCaptionButton}
        />
      )}
      <div className="flex mt-3">
        <Alertbox role="status" variant="default" marginTop="--spacing-3">
          {alertDescription}
        </Alertbox>
      </div>
      {buttonDescription && (
        <SendButton
          aria-label="botão de enviar código para o telefone"
          size="medium"
          isLoading={isLoading}
          disabled={disableSendButton}
          onClick={onSend}
          className="w-full"
        >
          {buttonDescription}
        </SendButton>
      )}
      {showFooter && isMobile && (
        <div className="flex mt-2 items-center flex-col justify-center">
          <span className="typo-body-medium">{footerDescription}</span>
          <Button size="medium" variant="link" className="mt-1" onClick={onClickFooterButton}>
            Clique aqui
          </Button>
        </div>
      )}
      {!isMobile && (
        <BackLink marginTop="--spacing-2" size="medium" onClick={onBack}>
          Voltar
        </BackLink>
      )}
    </Content>
  )
}

RevalidateCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  alertDescription: PropTypes.string,
  disableSendButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  showFooter: PropTypes.bool,
  onBack: PropTypes.func,
  onSend: PropTypes.func,
  onClickFooterButton: PropTypes.func,
  buttonDescription: PropTypes.string,
  footerDescription: PropTypes.string,
  error: PropTypes.exact({
    title: PropTypes.string,
    message: PropTypes.string,
    showContactUs: PropTypes.bool,
    customLink: PropTypes.exact({
      text: PropTypes.string,
      href: PropTypes.string,
    }),
  }),
  caption: PropTypes.exact({
    description: PropTypes.string,
    buttonDescription: PropTypes.string,
  }),
  callBackCaptionButton: PropTypes.func,
}
